<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

const instanceateAddress = (addressObj, geo) => {
    addressObj.name = 'MAIN';
    if (geo.geometry.lat){
        addressObj.lat = geo.geometry.lat;
    }else return null;
    if (geo.geometry.lng){
        addressObj.lng = geo.geometry.lng;
    }else return null;

    return addressObj;
}

export default {
    init: async (payload) => {
        const el = document.body;
        el.removeAttribute("class");

        try {
            payload.data.paymentType = 'BANK_SLIP';
            let response = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`).data;
            
            if (response && response.status==200){
                payload.AddressCompany = response.result.companyUser.company.address;
                payload.data.paymentType = response.result.companyUser.company.paymentType ? response.result.companyUser.company.paymentType : 'BANK_SLIP';
                // if(payload.data.paymentType == 'CREDIT_CARD'){
                //     response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.cards.getMainByCompany}`)).data;
                    
                //     payload.data._id = response.result._id;
                //     payload.data.number = response.result.lastDigits;
                //     payload.data.name = response.result.name;
                //     payload.data.document = response.result.document;
                //     payload.data.fantasyName = response.result.fantasyName;
                //     payload.data.documentType = response.result.documentType;

                //     console.log(payload.data);
                // }
            }
        } catch (error) {
        }
    },
    methods:{
        filter: function(){
            this.items = [];

            Request.do(this, 'POST', Request.getDefaultHeader(this), this.filters, `${Endpoints.bankSlips.getByCompany}`,
            (response)=>{//SUCCESS CALLBACK
                this.items = response.results;
            },
            (error)=>{//ERROR CALLBACK
            });
           
        },
        createBankSlip: async function(){
             let state = this;
            $('#spinner').modal('toggle');

            Request.do(state, 'POST', Request.getDefaultHeader(state), {}, `${Endpoints.bankSlips.generateBankSlip}`,
            (response)=>{//SUCCESS CALLBACK
                $('#spinner').modal('toggle');
                state.filter();

            },
            (error)=>{//ERROR CALLBACK
                 $('#spinner').modal('toggle');
            });
        },
        isCheckDate: function(date){
            if(date){
                let dueDate = new Date(date);
                let currentDate = new Date();
                dueDate.setHours(0,0,0,0);
                currentDate.setHours(0,0,0,0);

                if(currentDate <= dueDate){
                    return true
                }else{
                    return null;
                }
            }else{
                return null;
            }
        },
        save: async function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            this.data.isMain = true;

            if(this.data.document){
              this.data.document = this.data.document.replace(/\//g, '').replace(/\./g, '').replace(/\-/g, '');
            }

            try {
                let state = this;
                if(this.data.paymentType == 'CREDIT_CARD'){
                    let response = await Request.do(this, 'POST', Request.getDefaultHeader(this), this.address, `${Endpoints.addresses.address}`);
                }
                // else{
                //     this.data = {
                //          "paymentType": "BANK_SLIP"
                //     }
                // }
                Request.do(this, this.data.number ? 'PUT' : 'POST', Request.getDefaultHeader(this), this.data,`${Endpoints.cards.card}${this.data.number ? this.data._id : ''}`,
                async(companyResponse)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');
                    let responseme = (await Request.do(state, 'GET', Request.getDefaultHeader(state), {}, `${Endpoints.systemUsers.getMe}`)).data;
                    this.$session.set('user', responseme.result);
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            // this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
            });
            } catch (error) {
            }
            
        },
        onChangePage(pageOfItems) {
            this.pageOfItems = pageOfItems;
        },
        loadGeolocation: function (callbackSuccess, callbackError) {
            let state = this;
            Request.do(this, 'POST', Request.getDefaultHeader(this), this.address, `${Endpoints.addresses.geolocation}`,
                    (geoResponse)=>{//SUCCESS CALLBACK
                        if (geoResponse.results.length==0){
                            return callbackError(this.$t('string.company.register.address.invalid'));
                        }else if (geoResponse.results.length==1){
                            let geo = geoResponse.results[0];
                            let addressObj = instanceateAddress(state.address, geoResponse.results[0]);
                            console.log('geoResponse.results');
                            console.log(JSON.stringify(addressObj));
                            if (addressObj){
                                return callbackSuccess(state.data);
                            }else {
                                return callbackError(state.$t('string.company.register.address.invalid'));
                            }
                        }else if (geoResponse.results.length>1){
                            state.addresses = geoResponse.results;
                            $('#modalListAddress').modal('toggle');
                        } 
                    },
                    (error)=>{//ERROR CALLBACK
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else if (res.data.messageId === 'response.already.exists'){
                                this.messageToast = this.$t('response.user.already.exists');
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            $('#toast').modal('show');
                        }
                        
                    });        
        },
        selectAddress: function(index){
            let addressObj = instanceateAddress(this.address, this.addresses[index]);
            
            if (addressObj){
                addressObj.ibge = this.address.ibge;
                addressObj.gia = this.address.gia;
                addressObj.complement = this.complement;
                this.address = addressObj;
                $('#modalListAddress').modal('toggle');
                this.save(this.data);
            }else {
                this.errors = [];
                this.errors.push(this.$t('string.company.register.address.invalid'));
                 $('#modalListAddress').modal('toggle');
            }
        },
        loadInfosByCEP: function(){
            let state = this;
            if (this.address.cep && this.address.cep.length == 9){
                $('#spinner').modal('toggle');
                Request.do(this, 'GET', {}, {}, `${Endpoints.cep.find}${this.address.cep}/json`,
                    (response)=>{//SUCCESS CALLBACK
                        if (response){
                            state.address.address = response.logradouro;
                            state.address.neighborhood = response.bairro;
                            state.address.city = response.localidade;
                            state.address.state = response.uf;
                            state.address.ibge = response.ibge;
                            state.address.gia = response.gia;
                        }
                        
                        $('#spinner').modal('toggle');
                    },
                    (error)=>{//ERROR CALLBACK
                        $('#spinner').modal('toggle');
                        console.log(JSON.stringify(error));
                });
            }
        },
        checkForm: function (e) {
            this.errors = [];
            
            if(this.data.paymentType == 'CREDIT_CARD'){
              if (!this.data.number) {
                  this.errors.push(this.$t('response.card.register.number.required'));
              }
              if (!this.data.dueDate) {
                  this.errors.push(this.$t('response.card.register.dueDate.required'));
              }
              if (!this.data.cvv) {
                  this.errors.push(this.$t('response.card.register.cvv.required'));
              }
              if (!this.data.document) {
                  this.errors.push(this.$t('response.card.register.document.required'));
              }
              if (this.data.documentType =='CNPJ' && (this.data.fantasyName == '' || this.data.fantasyName == null) ) {
                  this.errors.push(this.$t('response.card.register.fantasyname.required'));
              }
              if (this.data.name == '' || this.data.name== null ) {
                  this.errors.push(this.$t('response.card.register.name.required'));
              }
              if (!this.address.cep) {
                  this.errors.push(this.$t('response.address.register.cep.required'));
              }
              if (this.address.state == -1) {
                  this.errors.push(this.$t('response.address.register.city.state.required'));
              }
              if (!this.address.city) {
                  this.errors.push(this.$t('response.address.register.city.required'));
              }
              if (!this.address.neighborhood) {
                  this.errors.push(this.$t('response.address.register.neighborhood.required'));
              }
              if (!this.address.address) {
                  this.errors.push(this.$t('response.address.register.address.required'));
              }
              if (!this.address.number) {
                  this.errors.push(this.$t('response.address.register.number.required'));
              }
            }

            if (this.errors.length==0){
                this.save();
            }else{
                e.preventDefault();
            }
        },

        clearForm: function(){

            this.data.paymentType = null;
          	this.data.number = null;
	        this.data.name = null;
	        this.data.dueDate = null;
	        this.data.cvv = null;
            this.data.isMain = null;
            this.data.document = null;
            this.data.fantasyName = null;
            this.data.documentType = null;
            this.address = {};
            this.errors=[];

        },
        getFantasyName: function(){
          this.data.fantasyName =  this.$session.get('user').companyUser.company.fantasyName;
        },
        getAddress: function(){
          // console.log(this.$session.get('user').companyUser)
          this.address =  this.AddressCompany;
          this.address.state = this.AddressCompany.state;
        },
        getCNPJ: function(){
            this.data.document =  this.$session.get('user').companyUser.company.document;
        },
        getSocialName: function(){
            this.data.bankNameOwner =  this.$session.get('user').companyUser.company.socialName;
        },
        camelize: Common.toUpperCase,
    }
}
</script>
